<template>

    <CobaltDashboard :info="null" :company="null" :withFilterBar="false" contentClasses="single ps-0 pe-0">

        <div class="np-home container">
            <div class="row h-100">
                <div class="col-lg-3 h-100">
                        <div class="np-group np-group-column h-100">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="np-group np-pb-3">
                                        <button class="np-btn np-light-gray np-p-custom-0 np-mr-2">
                                            <svg><use href="@/assets/images/icons/arrow-left.svg#icon"></use></svg>
                                        </button> 
                                        <div class="dashboard-content__filters-panel flex-grow-1">

                                        </div>
                                    </div> 
                                    <div class="np-group np-pb-3">
                                        <button class="np-btn np-btn-sm np-outline np-flex-1 np-mr-1">
                                            <svg class="icon"><use href="@/assets/images/icons/filter.svg#icon"></use></svg>                                                                        
                                            Фильтры
                                        </button>
                                        <button class="np-btn np-btn-sm np-outline np-flex-1 np-mr-1">
                                            <svg class="icon"><use href="@/assets/images/icons/sorting.svg#icon"></use></svg>                                                                        
                                            Сортировка
                                        </button>
                                        <button class="np-btn np-btn-primary-light np-p-custom-0">
                                            <svg><use href="@/assets/images/icons/edit.svg#icon"></use></svg>                                    
                                        </button>
                                    </div>          
                                </div>
                            </div>

                            <div class="np-group np-group-column np-flex-1">
                                <PerfectScrollbar>
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li class="active">
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3 active">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>  
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>     
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li class="active">
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3 active">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>  
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>     
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li class="active">
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3 active">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>  
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>     
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li class="active">
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3 active">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>  
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>     
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li class="active">
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3 active">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>  
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>     
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li class="active">
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3 active">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>  
                                    <Accordion>
                                        <ul class="tree-list">
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2 np-nb-3">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="np-group np-outline np-rounded np-p-custom-2">
                                                    <div class="cobalt-profile icon">MP</div>
                                                    <div class="np-group np-group-column np-pl-3">
                                                        <div class="header3 np-pb-1">Краснов Иван</div>
                                                        <div class="subheader3">Security Engineer</div>
                                                    </div>
                                                </div>
                                            </li>                                    
                                        </ul>
                                    </Accordion>                                                                                                                                                                                                  
                                </PerfectScrollbar>
                            </div>
                        </div>
                    
                </div>
                <div class="col-lg-4">
                    <div class="np-group np-group-column np-pb-4">
                        <div class="np-group np-mb-2">
                            <a class="cobalt-profile team-member__avatar nav-link" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                MP
                            </a>

                            <div class="np-group np-group-column">
                                <h2 class="np-header1">Иванов Иван</h2>
                                <span class="np-badge np-outline np-mt-2">Senior Full-stack разработчик</span>
                                <div class="np-group np-group-column np-flex-1 justify-content-end">
                                    <a class="np-header3 vertical-align-center np-pb-1" href="#"><img class="np-pr-2" src="@/assets/images/team/team-mail.svg"> email@email.em</a>
                                    <a class="np-header3 vertical-align-center np-pb-1" href="#"><img class="np-pr-2" src="@/assets/images/team/team-phone.svg"> +7 901 321 77 88</a>
                                </div>
                            </div>    
                        </div>

                        <div class="np-group np-group-column np-mt-4">
                            <div class="np-header3 np-pl-2">Участвую в проектах</div>
                            <div class="np-group np-flex-wrap">
                                <div class="np-badge-s np-inactive np-mt-2 np-mr-2">Testo</div>
                                <div class="np-badge-s np-inactive np-mt-2 np-mr-2">Это проект с весьма длинным названием, весьма</div>
                                <div class="np-badge-s np-inactive np-mt-2 np-mr-2">Это проект с весьма весьма</div>
                            </div>
                        </div>           
                    </div>                           

                    <div class="np-group np-group-column np-mt-2">
                        <div class="np-header2 vertical-align-center np-pb-4">
                            <svg class="np-mr-2"><use href="@/assets/images/icons/pie-chart.svg#icon"></use></svg> Процент выполнения
                        </div>
                    </div>

                    <div class="np-panel">

                        <div class="np-panel-body np-light">
                            <div class="np-group justify-content-around">
                                <div  class="np-group np-group-column align-items-center np-p-2">
                                    <Doughnut 
                                        style="max-width: 100px;"
                                        :data="chartOneData" 
                                        :options="{
                                            plugins: { legend: { display: false } },
                                            responsive: false,
                                            borderWidth: 1,
                                            cutout:35,
                                            maintainAspectRatio: false
                                        }" 
                                    />
                                    <div class="np-group np-subheader3 flex-nowrap np-mt-2"><span class="cobalt-bullet me-2" style="background-color: #142941"></span> Всего задач: 18</div>
                                </div>
                                <div  class="np-group np-group-column align-items-center np-p-2">
                                    <Doughnut 
                                        style="max-width: 100px;"
                                        :data="chartTwoData" 
                                        :options="{
                                            plugins: { legend: { display: false } },
                                            responsive: false,
                                            borderWidth: 1,
                                            cutout:35,                                            
                                            maintainAspectRatio: false
                                        }" 
                                    />
                                    <div class="np-group np-subheader3 flex-nowrap np-mt-2"><span class="cobalt-bullet me-2" style="background-color: #ADFFBC;"></span> Выполненные: 17</div>
                                </div>
                                <div  class="np-group np-group-column align-items-center np-p-2">
                                    <Doughnut 
                                        style="max-width: 100px;"
                                        :data="chartThreeData" 
                                        :options="{
                                            plugins: { legend: { display: false } },
                                            responsive: false,
                                            borderWidth: 1,
                                            cutout:35,                                            
                                            maintainAspectRatio: false
                                        }" 
                                    />
                                    <div class="np-group np-subheader3 flex-nowrap np-mt-2"><span class="cobalt-bullet me-2" style="background-color: #FF8F8F;"></span> Загруженность: 1</div>
                                </div>                                                        
                            </div>
                        </div>
                        <div class="np-panel-footer">
                            <div class="np-group justify-content-between">
                                <button class="stats-select-date"><span class="pe-2">24.01.2023 - 18.09.2023</span> <img src="@/assets/images/team/team-pencil.svg"> </button>                        
                            </div>
                        </div>                                                                                       
                        
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="np-group np-group-column">
                        <div class="np-header1 np-pt-4">Задачи</div>
                        <div class="np-fieldset np-pt-4">
                            <div class="np-group np-rounded-start np-p-2 align-items-center no-wrap">
                                <svg class="np-mr-1"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg>                            
                                <span class="np-mr-2">20</span>
                                <svg class="np-color-success np-mr-1"><use href="@/assets/images/icons/checked.svg#icon"></use></svg>                            
                                <span class="np-color-success np-mr-2">18</span>
                                <svg class="np-color-danger np-mr-1"><use href="@/assets/images/icons/close2.svg#icon"></use></svg>                            
                                <span class="np-color-danger">20</span>
                            </div>   
                            <vSelect class="np-rounded-end align-items-center np-outline np-mr-2 h-100" placeholder="Задача" :options="[
                                'Редизайн',
                                'Оптимизация бэкенда (Исполнитель Иванов ИВан Иванович)',
                                'Подготовить презентацию для к показу'
                            ]" />
                        </div>
                        <div class="np-panel np-mt-3">
                            <div class="np-table">
                                <div class="np-table-header">
                                    <div class="np-table-row">
                                        <div class="np-table-header-cell">
                                            <select><option>Название задачи</option></select>
                                        </div>
                                        <div class="np-table-header-cell">
                                            <select><option>Статус выполнения</option></select>
                                        </div>  
                                        <div class="np-table-header-cell">
                                            <select><option>Конец задачи</option></select>
                                        </div>   
                                        <div class="np-table-header-cell">
                                            <div class="np-group">
                                                <button class="np-btn np-btn-primary np-p-custom-0 np-mr-2">
                                                    <svg><use href="@/assets/images/icons/sertificate.svg#icon"></use></svg>
                                                </button>
                                                <button class="np-btn np-btn-primary np-p-custom-0 ">
                                                    <svg><use href="@/assets/images/icons/sertificate.svg#icon"></use></svg>
                                                </button>             
                                            </div>     
                                        </div>                                                                   
                                    </div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                    <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Оптимизация бэкенда (Исполнитель Иванов ИВан Иванович)</div>
                                    <div class="np-table-cell"><span class="np-badge np-danger">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Подготовить презентацию для к показу</div>
                                    <div class="np-table-cell"><span class="np-badge np-success">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Написать отчет по продажам</div>
                                    <div class="np-table-cell"><span class="np-badge np-freeze">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Проверить контент для соцсетей</div>
                                    <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Утвердить план проекта</div>
                                    <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>
                                <div class="np-table-row">
                                    <div class="np-table-cell">Редизайн главной панели (Лид)</div>
                                    <div class="np-table-cell"><span class="np-badge np-warning">Активно</span></div>
                                    <div class="np-table-cell">31.04.2025</div>
                                    <div class="np-table-cell"></div>
                                </div>                                                                                                                                                                        
                            </div>
                        </div>
                    </div>                      
                </div>
            </div>
        </div>

    </CobaltDashboard>

</template>

<script>

import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import CobaltDashboard from "@/components/dashboard/CobaltDashboard.vue"
import Accordion from '@/components/elements/Accordion.vue'
import { mapGetters, mapActions } from 'vuex';
import { DatePicker } from "qalendar";
import Config from '../config.js'
import "qalendar/dist/style.css";

export default {
    components: {
        CobaltDashboard,
        DatePicker,
        Doughnut,
        Accordion
    },
    data() {
        return {
            Config,
            compInfo: null,
        }
    },
    beforeMount: function () {
        //this.getListComp()
    },
    computed: {
        chartOneData: {
            get() {
                return {
                    labels: ["a", "b"],
                    datasets: [
                        {
                            backgroundColor: ['#DEE2E6', '#E46651'],
                            data: [18, 1]
                        }
                    ]
                }                
            } 
        },
        chartTwoData: {
            get() {
                return {
                    labels: ["a", "b"],
                    datasets: [
                        {
                            backgroundColor: ['#DEE2E6', '#41B883'],
                            data: [18, 16]
                        }
                    ]
                }                
            } 
        },
        chartThreeData: {
            get() {
                return {
                    labels: ["a", "b"],
                    datasets: [
                        {
                            backgroundColor: ['#DEE2E6', '#FDE047'],
                            data: [100, 75]
                        }
                    ]
                }                
            } 
        }                
    },
    methods: {
        ...mapActions('company', ['list', 'addCompany', 'delete']),
        ...mapGetters('company', ['getList']),      
    }

}
</script>

<style>
    .home {
        width: 100%;
        height: 100%;
    }
    .shelf {
        flex: 1 1 auto;
        width: 100%;
        margin-bottom: 10px;
        border: none;
        background-color: transparent;
        display: flex;
        flex-direction: row;
        font-size: 13px;
    }
    .shelf:last-child {
        margin-bottom: 0;
    }
    .labelbox {
        flex: 0 0 70%;
    }
    .valuebox {
        flex: 0 0 10%;
    }
    .valuebox img {
        width: 24px;
        opacity: .8;
    }
    .command-user__list-title.shelf {
        font-size: 14px;
        font-weight: 500;
    }
    .stats-select-date {
        padding: 10px 20px;
        font-size: 12px;
        background-color: #FFF;
        border: 10px;
        border-width: 0;
        box-shadow: 0 3px 5px rgb(0 0 0 / 4%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>